
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Churchgatetopune() {



    const cardData =
    {
        keyword: ' Church Gate to Pune Cab Service',
        heading: 'Skyline Cabs: Church Gate to Pune Cab Service',
        headingDescription: 'Skyline Cabs provides reliable and comfortable Churchgate to Pune Cab Service for a smooth and hassle-free intercity journey. Whether you are traveling for work, a family visit, or a weekend getaway, our well-maintained fleet and professional drivers ensure a safe and relaxing ride. With timely pickups from Churchgate, transparent pricing, and round-the-clock customer support, Skyline Cabs is your trusted choice for dependable travel. Book your Churchgate to Pune cab today and enjoy a stress-free, comfortable journey.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Churchgate to Pune Taxi Fare",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Churchgate to Pune. Our transparent pricing ensures you get the best value for your journey, with clear and competitive fare rates for a comfortable ride."
  },
  {
    "name": "Mumbai Central to Pune Cab",
    "description": "Travel comfortably from Mumbai Central to Pune with Skyline Cabs. Choose from a range of vehicles, including sedans and SUVs, for a smooth, safe, and hassle-free journey at competitive rates."
  },
  {
    "name": "CST to Pune Cab Service",
    "description": "Skyline Cabs offers dependable taxi services from CST to Pune. Whether you're heading for business or leisure, enjoy a comfortable ride in our well-maintained vehicles with experienced drivers."
  },
  {
    "name": "Mazdock to Pune Taxi Service",
    "description": "Skyline Cabs provides reliable taxi services from Mazdock to Pune. Enjoy a comfortable, safe ride with our fleet of vehicles, and experience smooth travel at affordable rates."
  },
  {
    "name": "Mumbai Central to Pune One Way Cab",
    "description": "Skyline Cabs offers one-way taxi services from Mumbai Central to Pune, ensuring a hassle-free, one-way trip with a vehicle suited to your needs. Book your ride today for a comfortable journey."
  },
  {
    "name": "Nariman Point to Pune Taxi Fare",
    "description": "Skyline Cabs provides competitive and affordable taxi fares for travel from Nariman Point to Pune. We offer reliable service, ensuring comfort and convenience with our well-maintained vehicles."
  },
  {
    "name": "Gateway of India to Pune Cab",
    "description": "Take a smooth and scenic ride from Gateway of India to Pune with Skyline Cabs. We offer comfortable and affordable rides with a variety of vehicle options, including sedans and SUVs."
  },
  {
    "name": "Worli Mumbai to Pune Cab",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Worli, Mumbai, to Pune. Enjoy a safe and comfortable ride with our professional drivers and fleet of well-maintained vehicles."
  },
  {
    "name": "Best Cab Service Mumbai to Pune",
    "description": "Skyline Cabs is the best choice for taxi services from Mumbai to Pune. With reliable, comfortable, and affordable options, our fleet includes a variety of vehicles to suit all your needs for a smooth journey."
  },
  {
    "name": "Mumbai Central to Pune Innova Crysta",
    "description": "For a premium and comfortable ride, choose our Innova Crysta taxis for your journey from Mumbai Central to Pune. Skyline Cabs offers spacious and luxury vehicles for a smooth and pleasant ride."
  },
  {
    "name": "Fort Mumbai to Pune Cab Service",
    "description": "Skyline Cabs offers reliable taxi services from Fort Mumbai to Pune. Whether you're looking for a one-way ride or a round trip, we ensure your journey is smooth, safe, and affordable."
  },
  {
    "name": "Taxi Service in Churchgate Station to Pune",
    "description": "Skyline Cabs offers comfortable taxi services from Churchgate Station to Pune. With experienced drivers and a fleet of vehicles, we ensure a safe, smooth, and timely journey."
  },
  {
    "name": "Churchgate to Pimpri Chinchwad Cab Service",
    "description": "Skyline Cabs provides reliable and affordable taxi services from Churchgate to Pimpri Chinchwad. Enjoy a comfortable ride with a range of vehicle options, including sedans and SUVs, for your convenience."
  }
],
"tableData": [
  ["Churchgate to Pune Taxi Fare", "Mumbai Central to Pune Cab"],
  ["CST to Pune Cab Service", "Mazdock to Pune Taxi Service"],
  ["Mumbai Central to Pune One Way Cab", "Nariman Point to Pune Taxi Fare"],
  ["Gateway of India to Pune Cab", "Worli Mumbai to Pune Cab"],
  ["Best Cab Service Mumbai to Pune", "Mumbai Central to Pune Innova Crysta"],
  ["Fort Mumbai to Pune Cab Service", "Taxi Service in Churchgate Station to Pune"],
  ["Churchgate to Pimpri Chinchwad Cab Service"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Churchgate to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Churchgate to Pune, ensuring that you reach your destination comfortably and on time. Whether it’s for business or leisure, we provide a smooth journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes a variety of well-maintained vehicles, such as sedans, SUVs, and luxury cars, all equipped with air-conditioning and ample space to ensure your ride from Churchgate to Pune is comfortable and relaxing."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs drivers are highly experienced and knowledgeable about the best routes from Churchgate to Pune. They ensure your comfort, safety, and punctuality, offering a stress-free journey from start to finish."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide affordable pricing for your Churchgate to Pune journey with no hidden charges. Skyline Cabs ensures that you know the fare upfront, making it easy to plan your trip while enjoying great value for your money."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, so you can book a ride from Churchgate to Pune at any time of the day or night. Whether it's a scheduled trip or a last-minute journey, we are always available to serve you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking a ride is quick and hassle-free with Skyline Cabs. Use our website or mobile app to book your cab in minutes and receive instant booking confirmation along with real-time tracking for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs",
        "WhyChoosedescription": "We prioritize your health and safety. All of our vehicles are sanitized before every ride, and our drivers follow strict safety protocols to ensure you travel in a hygienic and secure environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Skyline Cabs offers a variety of vehicles to fit your needs, whether you're traveling alone, with family, or in a group. From comfortable sedans to spacious SUVs, we ensure a comfortable and customized ride for your journey from Churchgate to Pune."
    }
]


























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Church Gate to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Church Gate to Pune is simple with Skyline Cabs. You can book online via our website or mobile app, or call our customer support team. Just enter your pickup and drop-off details, select your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Church Gate to Pune trip?',
            answer:
                'Skyline Cabs offers a wide range of vehicles for your trip, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on your group size and comfort preferences.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Church Gate to Pune?',
            answer:
                'The travel time from Church Gate to Pune typically ranges between 3.5 to 5 hours, depending on traffic conditions. Our experienced drivers ensure a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Church Gate to Pune cab fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed pricing for the Church Gate to Pune route. The fare includes all taxes, tolls, and driver charges, ensuring no hidden fees.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Church Gate to Pune?',
            answer:
                'Yes, you can book a round-trip cab from Church Gate to Pune. Simply provide your return trip details during the booking process, and we’ll arrange a comfortable round-trip for you.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Church Gate to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking through our website, app, or customer support team. We offer flexible options to accommodate changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Church Gate to Pune well-maintained?',
            answer:
                'Yes, all our vehicles are regularly maintained, cleaned, and inspected to ensure a safe, comfortable, and hassle-free journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Church Gate to Pune ride?',
            answer:
                'We offer secure online payment options, including credit/debit cards, UPI, and net banking. Alternatively, you can also pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Church Gate to Pune?',
            answer:
                'Yes, Skyline Cabs provides corporate travel services, offering timely and comfortable transport for business meetings, group travel, or conferences. Get in touch for custom corporate packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Church Gate to Pune journey?',
            answer:
                'Skyline Cabs offers professional drivers, well-maintained vehicles, transparent pricing, and reliable service. We ensure a smooth, comfortable, and punctual journey from Church Gate to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I took a cab from Church Gate to Pune, and it was a fantastic experience. The driver was on time, the car was clean, and the journey was comfortable. Highly recommended!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The service was great for my Church Gate to Pune trip. The car was well-maintained, and the driver was courteous. The only downside was a bit of traffic, but the ride was otherwise smooth."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Churchgate to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/churchgate-to-pune-cab.jpg",
  "description": "Book Churchgate to Pune cab with Skyline Cabs for a smooth, on-time, and comfortable ride. AC sedans, SUVs, and premium cabs available 24/7 with professional drivers for one-way and round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7428"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1450",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/churchgate-to-pune-cab"
  }
};


      
    



    return (
        <div>
<Helmet>
  <title>Churchgate to Pune Cab | AC Taxi Booking 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Churchgate to Pune cab with Skyline Cabs for a smooth, on-time, and comfortable ride. AC sedans, SUVs, and premium cabs available 24/7 with professional drivers for one-way and round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Churchgate to Pune Cab, Cab from Churchgate to Pune, One-Way Taxi Churchgate to Pune, Round Trip Cab Churchgate to Pune, AC Cab Churchgate to Pune, SUV Taxi Churchgate to Pune, Churchgate Pune Online Taxi Booking, 24/7 Cab Churchgate to Pune, Skyline Cabs Churchgate Pune, Affordable Taxi Churchgate to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/58.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Churchgatetopune;